module.exports = __webpack_public_path__ + "static/img/2.e0101d5b.png";